import gql from 'graphql-tag'

export default gql`
mutation passwordReset($email: String!) {
    passwordReset(email: $email)
}
`
